import { jsx as i } from "react/jsx-runtime";
import "react";
import { u as n } from "../useTheme-CAzYaPx6.js";
import s from "../LoadingCircle/LoadingCircle.js";
import { s as r } from "../styled-C9zyPXdj.js";
const p = r("span")({
  display: "flex",
  alignItems: "center",
  position: "absolute"
}), l = {
  56: "20px",
  48: "18px",
  40: "16px",
  32: "16px",
  24: "14px"
}, c = ({
  theme: t,
  appearance: e,
  intent: a
}) => ({
  solid: {
    neutral: t.palette["base/white/white"],
    prominent: t.palette["base/white/white"],
    negative: t.palette["base/white/white"]
  },
  outline: {
    neutral: t.palette["text/contrast-max"],
    prominent: t.palette["text/status-prominent"],
    negative: t.palette["text/status-negative"]
  },
  ghost: {
    neutral: t.palette["text/contrast-max"],
    prominent: t.palette["text/status-prominent"],
    negative: t.palette["text/status-negative"]
  }
})[e][a], x = ({
  appearance: t,
  intent: e,
  size: a = "48"
}) => {
  const o = n();
  return /* @__PURE__ */ i(p, { children: /* @__PURE__ */ i(
    s,
    {
      size: l[a],
      thickness: 1.5,
      color: c({ theme: o, appearance: t, intent: e })
    }
  ) });
};
x.displayName = "LoadingCircle";
export {
  x as default
};
//# sourceMappingURL=LoadingCircle.js.map
